export const comma = function (value) {
  if (value == null || String(value).trim().length === 0) {
    return "";
  }
  return Number(value).toLocaleString();
};
